<script setup lang="ts">
import KTime from '@/components/times/KTime.vue';
import * as commonConstants from '@/constants/common';

export interface Props {
  id?: string | number;
  name?: string;
  datetime?: string;
  message?: string;
  icon?: string;
  isOwn?: boolean;
}
export type SmsChatMessageFullUnitProps = Props;

const props = withDefaults(defineProps<Props>(), {
  id: undefined,
  name: commonConstants.EM_DASH,
  datetime: undefined,
  message: commonConstants.EM_DASH,
  icon: 'mdi-check',
  isOwn: false,
});
</script>

<template>
  <article
    :class="[$style.smsChatMessageFullUnit, { [$style.own]: props.isOwn }]"
    data-testid="smsChatMessageFullUnit"
  >
    <address :class="$style.name">{{ props.name }}</address>
    <div :class="$style.wrapper">
      <div :class="$style.message">
        {{ props.message }}
      </div>
      <footer :class="$style.footer">
        <KTime :datetime="props.datetime" :class="$style.time" />
        <v-icon v-if="props.datetime" :class="$style.icon" :icon="props.icon" />
      </footer>
    </div>
  </article>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatMessageFullUnit {
  display: flex;
  flex-direction: column;
  align-items: start;

  &.own {
    align-items: end;
  }
}
  .name {
    font-style: normal;
    font-size: 16px;
    font-weight: 500;
    margin-top: 12px;
    margin-bottom: 8px;
  }
  .wrapper {
    background-color: colors.$color-brand-50;
    border-radius: 18px;
    padding: 8px 16px;
    width: auto;
  }
  .smsChatMessageFullUnit.own .wrapper {
    background-color: colors.$color-gray-100;
    border-top-right-radius: 0;
  }
  .smsChatMessageFullUnit:not(.own) .wrapper {
    border-top-left-radius: 0;
  }
    .message {
    }
    .footer {
      text-align: right;
      margin-top: 4px;
    }
      .time {
        font-size: 12px;
        color: colors.$color-text-tertiary;
        font-weight: 500;
      }
      .icon {
        margin-left: 12px;
        margin-right: 6px;
        font-size: 16px;
        color: colors.$color-text-tertiary;
      }
</style>
